module.exports = __webpack_public_path__ + "img/Sebacic-acid.d8060163.png";